import GigyaRegisterController from '@/utils/Controllers/Gigya/GigyaRegisterController';

document.addEventListener('DOMContentLoaded', () => {
  GigyaRegisterController.init();
});
